// Matches a DGB garage vehicle against the vehicle a guest quoted pre-login,
// preferring VIN when both sides have one (most reliable), falling back to
// year/make/model otherwise. Good enough for low-stakes decisions like
// which mileage to display on a card that's already unambiguously a
// specific vehicle - NOT good enough to decide whether to suppress an
// entire card. See isConfirmedDuplicateVehicle for that.
export const isQuotedVehicle = (vehicle, quotedVehicle) => {
  if (quotedVehicle?.vin && vehicle?.vin) {
    return quotedVehicle.vin.toUpperCase() === vehicle.vin.toUpperCase();
  }
  return (
    !!quotedVehicle?.year &&
    String(quotedVehicle.year) === String(vehicle?.year) &&
    quotedVehicle.make?.toLowerCase() === vehicle?.make?.toLowerCase() &&
    quotedVehicle.model?.toLowerCase() === vehicle?.model?.toLowerCase()
  );
};

// Returns true only when we can be CERTAIN a DGB vehicle is the same one
// the guest just quoted - i.e. both sides have a VIN and it matches.
// A year/make/model match alone isn't enough: if the guest quoted without
// a VIN (e.g. the year/make/model tab), a same-Y/M/M DGB vehicle could
// genuinely be a different car they also own. Use this - not
// isQuotedVehicle - to decide whether to suppress showing the guest's
// quoted vehicle as its own card; when in doubt, show it rather than risk
// silently hiding a real, never-inspected vehicle.
export const isConfirmedDuplicateVehicle = (vehicle, quotedVehicle) => {
  if (!quotedVehicle?.vin || !vehicle?.vin) {
    return false;
  }
  return quotedVehicle.vin.toUpperCase() === vehicle.vin.toUpperCase();
};
